import React from 'react'
import AnnotationHeader from './AnnotationHeader'
import PubAnnotations from './PubAnnotations'

import ScissorsIcon from 'src/images/icons/scissors_icon.svg'

class RemovePagesAnnotation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {disabled: true, error: false}
    this.handlePageChanged = this.handlePageChanged.bind(this)
    this.handleSave = this.handleSave.bind(this)
  }

  handlePageChanged(evt) {
    let obj = {}
    const key = `page${$(evt.target).data('id')}`
    obj[key] = $(evt.target).val()
    this.setState(obj);
  }

  handleSave() {
    PubAnnotations.init().saveRemovePagesAnnotation(
      this.props.annotation,
      this.enteredPages().map((val) => Number(val))
    );
  }

  fourValidPagesEntered() {
    return this.numeric() && this.unique();
  }

  componentDidUpdate(){
    if (this.numeric() && !this.state.error) {
      if (this.unique() && this.state.disabled){
        this.setState({disabled: false})
      } else if (!this.unique()) {
        this.setState({error: true})
      }
    } else if (this.fourValidPagesEntered() && this.state.error) {
      this.setState({disabled: false, error: false})
    } else if ( !this.fourValidPagesEntered() && !this.state.disabled) {
      this.setState({disabled: true})
    }
  }

  enteredPages() {
    return this.removablePagesArray().map((pg) => this.state["page" + pg])
  }

  numeric(){
    return this.enteredPages().every((val) => $.isNumeric(val));
  }

  unique(){
    return (new Set(this.enteredPages())).size == this.enteredPages().length;
  }

  removablePagesArray() {
    if (this.props.pagesPerSheet == 2) {
      return [1,2]
    } else {
      return [1,2,3,4]
    }
  }

  render() {
    const hiddenClass = this.state.error ? '' : 'hidden'
    const values = this.enteredPages().filter(Number).length == this.props.pagesPerSheet ? this.enteredPages() : this.removablePagesArray()
    const pageBoxes = values.map((pg, i) => {
      let arr = values.filter(function(i) { return i == pg.toString() })
      let errorClass = this.state.error && arr.length >= 2 ? 'remove-page-danger' : ''
      return <input key={i} type="text" className={`remove-page ${errorClass}`} maxLength="2" data-id={pg} onChange={this.handlePageChanged} />
    })

    return (
      <div className="card p-0">
        <AnnotationHeader
          onSelect={this.props.onSelect}
          annotation={this.props.annotation}
          roleType={this.props.roleType}
          annotationTypes={this.props.annotationTypes} />

        <div className="text-center py-5 grey-text text-darken-2 px-4">
          <img className='m-auto pb-2' src={ScissorsIcon}/>
          <h1>{`Which ${this.props.pagesPerSheet} pages would you like to remove?`}</h1>
        </div>

        <div className="text-center pb-2 px-4">
          {pageBoxes}
        </div>
        <div>
          <p className={`text-center red-text mb-0 ${hiddenClass}`}>{`Please enter ${this.props.pagesPerSheet} unique page numbers.`}</p>
        </div>
        <div className="d-flex flex-row justify-content-end pb-4 px-4">
          <button className="btn-flat" ref="removePagesBtn" disabled={this.state.disabled} onClick={this.handleSave}>Remove Pages</button>
        </div>
      </div>
      )
  }
}

export default RemovePagesAnnotation
